export const TYPED_ENV = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_MAPS_API_KEY: import.meta.env.VITE_MAPS_API_KEY,
  VITE_FRONT_BASE_URL: import.meta.env.VITE_FRONT_BASE_URL,
  VITE_STAGING: import.meta.env.VITE_STAGING,
  VITE_FACEBOOK_CONVERSIONS_API_TOKEN: import.meta.env
    .VITE_FACEBOOK_CONVERSIONS_API_TOKEN,
  VITE_FACEBOOK_CONVERSIONS_API_VERSION: import.meta.env
    .VITE_FACEBOOK_CONVERSIONS_API_VERSION,
  VITE_FACEBOOK_PIXEL_ID: import.meta.env.VITE_FACEBOOK_PIXEL_ID,
  VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
} as const;
